export function capitalize(s) {
    return s[0].toUpperCase() + s.slice(1);
}
export function toTitleCase(str) {
    return str.replace(/\w\S*/g, w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
}
